import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navigation from './components/navigation/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/home/Home';
import Products from './pages/products/Products';
import ProductDetail from './pages/products/ProductDetail';
import Services from './pages/services/Services';
import BackOffice from './pages/services/BackOffice';
import ECommerce from './pages/services/ECommerce';
import Contact from './pages/contact/Contact';
import Pricing from './pages/pricing/Pricing';
import Privacy from './pages/legal/Privacy';
import Terms from './pages/legal/Terms';
import Landing from './pages/landing/Landing';
import DocsHome from './pages/docs/DocsHome';
import CimmplePayDocsExplorer from './pages/docs/cimmplepay/CimmplePayDocsExplorer';
import CimmpleFlowDocsOverview from './pages/docs/cimmpleflow/CimmpleFlowDocsOverview';
import CimmplePayHelpExplorer from './pages/help/cimmplepay/CimmplePayHelpExplorer';
import { useMarket } from './context/MarketContext';

function App() {
  const { isLoading } = useMarket();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white dark:bg-dark-950">
        <div className="text-center" role="status" aria-live="polite">
          <div className="w-10 h-10 mx-auto rounded-full border-4 border-primary-100 dark:border-dark-700 border-t-primary-600 animate-spin" />
          <span className="sr-only">Loading Cimmple</span>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <Navigation />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:productId" element={<ProductDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/e-commerce" element={<ECommerce />} />
          <Route path="/services/back-office" element={<BackOffice />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/lp" element={<Landing />} />
          <Route path="/docs" element={<DocsHome />} />
          <Route path="/docs/cimmplepay/*" element={<CimmplePayDocsExplorer />} />
          <Route path="/help/cimmplepay/*" element={<CimmplePayHelpExplorer />} />
          <Route path="/docs/cimmpleflow" element={<CimmpleFlowDocsOverview />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;

